import {
  PLANS_LOADED,
  PLANS_LOADED_ERROR,
  SELECTED_PLAN,
  CREATE_SUBSCRIPTION_SUCCESS,
} from "../actions/ActionTypes";

const initialState = {
  plans: [],
  selectedPlan: {},
  error: "",
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case PLANS_LOADED:
      return {
        ...state,
        plans: payload,
        selectedPlan: payload.find((item) => item.name === "Annual") || {},
      };

    case PLANS_LOADED_ERROR:
      return {
        ...state,
        error: payload,
      };

    case SELECTED_PLAN:
      return {
        ...state,
        selectedPlan: payload,
      };

    case CREATE_SUBSCRIPTION_SUCCESS:
      return { ...state };

    default:
      return state;
  }
}
